import Stack from "@mui/material/Stack";
import { Outlet } from "react-router-dom";

import Header from "../components/header";

function ProtectedLayout(): React.JSX.Element {
  return (
    <>
      <Header />
      <Stack
        alignItems="center"
        sx={{
          paddingY: 4,
        }}
      >
        <Outlet />
      </Stack>
    </>
  );
}

export default ProtectedLayout;
